import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { green, grey } from "@material-ui/core/colors";
import { DifferenceCell, getPercentageChange } from "../../pages/Dashboard";
import { ImgCotacao } from "../Feed/CotacaoInfo";
import { Watermark } from "./Contratos";

export default function IceStocksRobusta({ iceReports }) {
  return (
    <TableContainer
      component={Paper}
      style={{ marginTop: 40, width: "35%", position: "relative" }}
    >
      <Watermark isSmall />
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <div
                style={{
                  display: "flex",
                  gap: 4,
                  alignItems: "center",
                }}
              >
                <ImgCotacao isLondres />
                ICE Stocks Londres
              </div>
            </TableCell>
            <TableCell style={{ textAlign: "right" }}> Total Sacos</TableCell>
            <TableCell style={{ paddingLeft: 12 }}>%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Variação</TableCell>
            <DifferenceCell
              iceReports={iceReports}
              keyName={"totalBagsRobusta"}
            />
            <TableCell></TableCell>
          </TableRow>
          {iceReports?.map((row, index) => {
            const next = iceReports[index + 1];
            const bagsChange = next
              ? getPercentageChange(row.totalBagsRobusta, next.totalBagsRobusta)
              : null;

            const getColor = (val) => {
              if (val == null) return undefined;
              return parseFloat(val) < 0 ? "red" : green[500];
            };

            if (!row?.totalBagsRobusta) return null;

            return (
              <TableRow key={`robusta-${row._id}`}>
                <TableCell>
                  {new Date(row.createdAt).toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  })}
                </TableCell>
                <TableCell style={{ textAlign: "right" }}>
                  {row.totalBagsRobusta?.toLocaleString() ?? "—"}
                </TableCell>
                <TableCell
                  style={{
                    color: getColor(bagsChange),
                    paddingLeft: 12,
                  }}
                >
                  {bagsChange != null ? `${bagsChange}%` : "—"}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
